// extracted by mini-css-extract-plugin
export var articleInfoContainer = "S_cG";
export var articleInfoItem = "S_cH";
export var itemChild = "S_cJ";